import request from "../base-request";

export interface FetchNewSelectionObjectProps {
	selection_object_id_to_copy?: string;
}

/**
 * Creates a new selection object
 * @returns The ID of the new selection object
 */
export const fetchNewSelectionObject = async (props?: FetchNewSelectionObjectProps) => {
	const [data] = await request<{ user_selection_id: string }>("/api/user_selection", {
		method: "POST",
		...(props ? { body: JSON.stringify(props) } : {}),
	});

	return data;
};

/**
 * This will add users to a user selection object
 */
export const addUserToSelectionObject = async (selectionObjectID: string, userIDs: string[]) => {
	const url = `/api/user_selection/${selectionObjectID}/add/`;
	const [data] = await request(url, {
		method: "POST",
		body: JSON.stringify({ users: userIDs }),
	});

	return data;
};

/**
 * This will remove users from a user selection object
 */
export const removeUserFromSelectionObject = async (selectionObjectID: string, userIDs: string[]) => {
	const url = `/api/user_selection/${selectionObjectID}/remove/`;
	const [data] = await request(url, {
		method: "POST",
		body: JSON.stringify({ users: userIDs }),
	});

	return data;
};

/**
 * Fetches the number of employees in a user selection object.
 */
export const fetchSelectionObjectCount = async (selectionObjectID: string) => {
	const url = `/api/user_selection/${selectionObjectID}/count/`;
	const [data] = await request<{ count: number }>(url);

	return data;
};
